module.exports = {"230805001":"晓云街道","230805002":"佳东街道","230805003":"造纸街道","230805004":"佳南街道","230805005":"建国街道","230805100":"建国镇","230805200":"松江乡","230805579":"东风区农垦"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230805.json
// module id = 760
// module chunks = 0